export default __webpack_public_path__ + "static/media/correspondent14.77bede21.png";